
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_swimc_v2jm7_93",
  "anchor-list": "awsui_anchor-list_swimc_v2jm7_128",
  "anchor-item": "awsui_anchor-item_swimc_v2jm7_146",
  "anchor-item--active": "awsui_anchor-item--active_swimc_v2jm7_165",
  "anchor-link": "awsui_anchor-link_swimc_v2jm7_179",
  "anchor-link--active": "awsui_anchor-link--active_swimc_v2jm7_218",
  "anchor-link-text": "awsui_anchor-link-text_swimc_v2jm7_225",
  "anchor-link-info": "awsui_anchor-link-info_swimc_v2jm7_229"
};
  